import React, {Component} from 'react';
import {Bar} from 'react-chartjs-2';

// set = {
//  color: 'rgb(15, 99, 105, 0.8)',
//  hover_color: 'rgb(15, 99, 105, 1)',
//  name: 'WBTC Premiums',
//  data: [50, 100, 200]
// }
export function standard_bar(sets, labels, options, title) {
		let datasets = [];
		for (let set of sets) {
				datasets.push(
					{
						label: set['name'],
						fill: false,
						lineTension: 0.1,
						backgroundColor: set['color'],
						borderColor: 'rgba(244,168,80,1)',
						borderCapStyle: 'butt',
						borderDash: [],
						borderDashOffset: 0.0,
						borderJoinStyle: 'miter',
						pointBorderColor: 'rgba(244,168,80,1)',
						pointBackgroundColor: '#fff',
						pointBorderWidth: 2,
						pointHoverRadius: 10,
						pointHoverBackgroundColor: set['hover_color'],
						pointHoverBorderColor: 'rgba(220,220,220,1)',
						pointHoverBorderWidth: 2,
						pointRadius: 1,
						pointHitRadius: 10,
						data: set['data']
					}
				)
		}
		const data = {labels: labels, datasets: datasets};
		return (
			<div className="barchart-v1">
				<h2>{title}</h2>
				<Bar data={data} options={options}/>
			</div>
		);
}

